module.exports = __webpack_public_path__ + "static/media/image014.a8243796.jpg";